// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__CdWWv","inner":"Footer_inner__10h7i","nextIcon":"Footer_nextIcon__1wpBQ","innerLeft":"Footer_innerLeft__3_iXv"};